const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
  }

const checkEmail = (email) => {
    // Is empty?
    if (email === '') {
        return 'Please enter your email.'
    }
    if (!validateEmail(email)) {
        return 'Please enter a valid email.'
    }
    return false
}


const checkCheckboxes = () => {
    let isProgram = document.getElementById('programs-toggle-unselected').classList.contains('inactive')
    let isStore = document.getElementById('store-toggle-unselected').classList.contains('inactive')
    let isBroadcast = document.getElementById('broadcast-toggle-unselected').classList.contains('inactive')

    if (!isProgram && !isStore && !isBroadcast) {
        // Nothing is selected ~ trigger error
        setError('Please select at least one newsletter option.')
        return false
    }

    return {
        isProgram,
        isStore,
        isBroadcast
    }
}

const onEmailInput = () => {
    let emailEl = document.getElementById("cta_input")
    let emailErrorEl = document.getElementById("email_error")
    emailEl.classList.remove('error')
    emailErrorEl.innerText = '' 
    emailEl.removeEventListener('input', onEmailInput)
    let checkboxErrorEl = document.getElementById("checkbox_error")
    checkboxErrorEl.innerText = ''
    checkboxErrorEl.classList.remove('active')
}

const onConfirmationClose = () => {
    document.getElementById('signup_modal').classList.remove('inactive')
    document.getElementById('success_modal').classList.add('inactive')
    onNewsletterClose()
}

const setConfirmation = ({isError, message}) => {
    document.getElementById('signup_modal').classList.add('inactive')
    document.getElementById('success_modal').classList.remove('inactive')
    document.getElementById('success_title').innerText = isError ? 'Oops!' : `You're subscribed!`
    document.getElementById('success_text').innerText = isError ? message : `We'll be in touch shortly.`
    document.getElementById('close_button').addEventListener('click', onConfirmationClose)
}

const setError = (message) => {
    let checkboxErrorEl = document.getElementById("checkbox_error")
    checkboxErrorEl.innerText = message
    checkboxErrorEl.classList.add('active')
    let emailEl = document.getElementById("cta_input")
    emailEl.addEventListener('input', onEmailInput)
}

const subscribe = async () => {
    // Check if there's an error with email
    let emailEl = document.getElementById("cta_input")
    let isEmailError = checkEmail(emailEl.value)

    if (isEmailError) {
        let emailErrorEl = document.getElementById("email_error")
        emailEl.classList.add('error')
        emailErrorEl.innerText = isEmailError 
        emailEl.addEventListener('input', onEmailInput)
        return
    }

    // Check to make sure that at least one checkbox is checked
    let whichCheckboxes = checkCheckboxes()
    if (!whichCheckboxes) return

    // If not, sign up
    await fetch('https://server.pioneerworks.org/.netlify/functions/newsletter', {
        method: 'POST',
        body: JSON.stringify({
            action: 'subscribe',
            email: emailEl.value,
            options: whichCheckboxes
        })
    })
    .then(res => res.json())
    .then((data) => {
        switch (data.message) {
            case "Member exists":
                setError(`Please enter a new email. ${emailEl.value} is already subscribed.`)
                return
            default:
                setConfirmation({
                    isError: false,
                    message: `${emailEl.value} is successfully subscribed!`,
                })
                return
          }
    })    
    .catch(err => {
        console.error(err)
        setConfirmation({
            isError: true,
            message: 'Please retry later. Unable to add to newsletter.'
        })
    })
    
}

const onFormSubmit = (ev) => {
    ev.preventDefault()
    let inputEl = document.getElementById('FooterNewsletterFormEmail')
    let value = inputEl.value
    document.getElementById('cta').style.display = 'block'
    document.getElementById('cta_input').value = value ? value : ''
    inputEl.value = ''
}

const onSegmentClick = (ev) => {
    // Toggle option
    let selectedEl = document.getElementById(`${ev.target.dataset.which}-toggle-selected`)
    let deselectedEl = document.getElementById(`${ev.target.dataset.which}-toggle-unselected`)
    if (!selectedEl) return
    let toDeselect = selectedEl.classList.contains('inactive')
    if (toDeselect) {
        selectedEl.classList.remove('inactive')
        deselectedEl.classList.add('inactive')
    } else {
        deselectedEl.classList.remove('inactive')
        selectedEl.classList.add('inactive')
    }

    // Remove error if it's present
    let checkboxErrorEl = document.getElementById("checkbox_error")
    checkboxErrorEl.classList.remove('active')
}

const onNewsletterClose = ev => {
    // Reset newsletter ~ clear email input
    let inputEl = document.getElementById("cta_input")
    inputEl.classList.remove('error')
    inputEl.value = ''
    let emailErrorEl = document.getElementById("email_error")
    emailErrorEl.innerText = ''

    // Reset newsletter ~ check all boxes
    let which = ['programs', 'broadcast', 'store']
    which.forEach(item => {
        document.getElementById(`${item}-toggle-selected`).classList.remove('inactive')
        document.getElementById(`${item}-toggle-unselected`).classList.add('inactive')
    })

    // Reset newsletter ~ clear checkbox error
    document.getElementById("checkbox_error").classList.remove('active')

    document.getElementById('cta').style.display = 'none'
}

const onCTAClick = (ev) => {
    if (ev.target.id === 'cta_container') {
        onNewsletterClose()
    }
}

async function setupNewsletter() {
    // Footer sign up button
    let formEl = document.getElementById("CustomFooterNewsletter")
    formEl.addEventListener('submit', onFormSubmit)
    let buttonEl = document.getElementById("FormButton")
    buttonEl.addEventListener('click', onFormSubmit)

    // Quit button
    let quitButton = document.getElementById('close-button')
    quitButton.addEventListener('click', onNewsletterClose)

    // Option click
    let segmentEls = document.getElementsByClassName("segment")
    Array.from(segmentEls).forEach(segmentEl => {
        segmentEl.addEventListener('click', onSegmentClick)
    })

    // CTA sign up button
    let signupButtonEl = document.getElementById("signup_button")
    signupButtonEl.addEventListener("click", subscribe)

    // Quit out of CTA
    document.addEventListener('click', onCTAClick)
}

setupNewsletter()